import {
  CreateSubfolder,
  Delete,
  Divider,
  Download,
  Rename,
  UploadFile,
} from './components';

const FileTreeContextMenuRoot: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return <>{children};</>;
};

export const FileTreeContextMenu = Object.assign(FileTreeContextMenuRoot, {
  Delete,
  CreateSubfolder,
  Download,
  Rename,
  UploadFile,
  Divider,
});
